import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: () => ({
    id: null,
    full_name: null,
    telephone: null,
    email: null,
    postcode: null,
    address_city: null,
    address_street: null,
    address_street_number: null,
    address_street_district: null,
    address_street_complement: null,
    address_state: null,
    document_number: null,
  }),
  actions,
  mutations,
  getters,
}
